import { ContentShare, useContentShareControls } from 'amazon-chime-sdk-component-library-react';
import classNames from 'classnames';
import React from 'react';
import { ScreenShare as ScreenShareIcon } from '../../../../icons';
import { useSession } from '../../../session-provider';
import { useVideoConfig } from '../../../video-config-provider';
import { Content } from '../content';
import ts from '../tile.scss';
import s from './screen-share.scss';
export var ScreenShare = function () {
    var _a, _b, _c;
    var _d = useVideoConfig(), mobile = _d.mobile, texts = _d.texts, dashboard = _d.dashboard;
    var _e = useSession(), currentAttendeeId = _e.currentAttendeeId, sharingAttendeeId = _e.sharingAttendeeId;
    var toggleContentShare = useContentShareControls().toggleContentShare;
    if (!sharingAttendeeId) {
        return null;
    }
    return (React.createElement(Content, { className: classNames(s.root, ts.tile, (_a = {}, _a[s.mobile] = mobile, _a[s.dashboardContainer] = dashboard, _a)), attendeeId: sharingAttendeeId, hideIndicators: true },
        React.createElement(ContentShare, { className: classNames(s.root, ts.tile) }),
        currentAttendeeId === sharingAttendeeId && (React.createElement("div", { className: s.buttonContainer },
            React.createElement("div", { className: classNames(s.text, (_b = {}, _b[s.dashboardText] = dashboard, _b)) }, texts.sharingScreen),
            React.createElement("button", { className: classNames(s.button, (_c = {}, _c[s.dashboardButton] = dashboard, _c)), onClick: toggleContentShare },
                !dashboard && React.createElement(ScreenShareIcon, null),
                texts.stopSharing)))));
};
//# sourceMappingURL=screen-share.js.map